export class HanteraLagermalTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        leaveDirtyHeader: "Osparade förändringar",
        leaveDirtyBody: "En eller flera värden är osparade i tabellen",
        changeDirtyHeader: "Osparade förändringar",
        changeDirtyBody: "En eller flera värden är osparade i tabellen. Är du säker på att du vill byta vy?"
    };
}
